import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-check-payment',
  templateUrl: './check-payment.component.html',
  styleUrls: ['./check-payment.component.scss']
})
export class CheckPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
